// import store from '@/store/index.js'
// let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 8,
            placeholder: '请选择学院',
            model: "collegeId",
            type: "select",
            options:[]
        },
    ]
    const tableColumns = [
        {
            label: "系(院)",
            prop: "11",
            align: "center",
            show: true
        },
        {
            label: "未贷款",
            prop: "22",
            align: "center",
            show:true
        },
        {
            label: "已贷款",
            prop: "33",
            align: "center",
            show:true,
            children: [
                {
                    label: "4000元以下",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "4000元-8000元",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "8000-10000元",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "10000元以上",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
            ]
        },
    ]

    return {
        searchItems,
        tableColumns
    }
}
